import { Children, isValidElement } from "react";

interface SpaceMergedSectionProps {
    /** Shown above merged content (e.g. "Merged topics"). */
    title: string;
    children: React.ReactNode;
    className?: string;
    /** When set, the section is omitted if this is zero (avoids empty wrapper divs). */
    itemCount?: number;
}

/**
 * Renders a titled block for merged content only when there is at least one child to show.
 */
export function SpaceMergedSection({ title, children, className, itemCount }: SpaceMergedSectionProps) {
    if (itemCount !== undefined) {
        if (itemCount <= 0) return null;
    } else {
        const count = Children.toArray(children).filter((c) => c != null && c !== false && isValidElement(c)).length;
        if (count === 0) return null;
    }

    return (
        <div className={className}>
            <div className="flex items-center gap-2 py-3 mt-2">
                <div className="h-px flex-1 bg-border" />
                <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground shrink-0">{title}</span>
                <div className="h-px flex-1 bg-border" />
            </div>
            <div className="space-y-2 min-w-0">{children}</div>
        </div>
    );
}
